export const MAX_SELECTED_ACQUISITION_ORDERS = 30;

export const batchEditModes = {
  ADD: 'add',
  REPLACE: 'replace',
  DELETE: 'delete',
};

// Shared by the batch edit modal and its saga, so both agree on the result
export const applyBatchEditMode = (currentIds, selectedIds, mode) => {
  const current = currentIds || [];
  switch (mode) {
    case batchEditModes.ADD:
      return [...new Set([...current, ...selectedIds])];
    case batchEditModes.REPLACE:
      return [...new Set(selectedIds)];
    case batchEditModes.DELETE:
      return current.filter((id) => !selectedIds.includes(id));
    default:
      return [...current];
  }
};

export default batchEditModes;
